import { types } from 'mobx-state-tree';

const toMaybeString = v => (v == null || typeof v === 'string') ? v : undefined;
const toMaybeNumber = v => (v == null || typeof v === 'number') ? v : (isNaN(Number(v)) ? undefined : Number(v));

export const ProspectProfile = types.model({
    industry: types.maybe(types.string),
    minRevenue: types.maybe(types.number),
    maxRevenue: types.maybe(types.number),
    location: types.maybe(types.string),
    minNumberOfEmployees: types.maybe(types.number),
    maxNumberOfEmployees: types.maybe(types.number),
    budgetForOffering: types.maybe(types.number),
    specificCharacteristics: types.maybe(types.string)
}).preProcessSnapshot(snapshot => ({
    ...snapshot,
    industry: toMaybeString(snapshot.industry),
    location: toMaybeString(snapshot.location),
    specificCharacteristics: toMaybeString(snapshot.specificCharacteristics),
    minRevenue: toMaybeNumber(snapshot.minRevenue),
    maxRevenue: toMaybeNumber(snapshot.maxRevenue),
    minNumberOfEmployees: toMaybeNumber(snapshot.minNumberOfEmployees),
    maxNumberOfEmployees: toMaybeNumber(snapshot.maxNumberOfEmployees),
    budgetForOffering: toMaybeNumber(snapshot.budgetForOffering),
}));

export const NullProspectProfile = ProspectProfile.create({
    industry: '',
    minRevenue: undefined,
    maxRevenue: undefined,
    location: '',
    minNumberOfEmployees: undefined,
    maxNumberOfEmployees: undefined,
    budgetForOffering: undefined,
    specificCharacteristics: ''
});